<script lang="ts" setup>
import type { StrapiPageError } from '@autobid/strapi-integration/typescript/strapi/Page'

definePageMeta({
  layout: 'strapi',
})

const slug = useRoute().path

function handleError(error: StrapiPageError) {
  showError({
    statusCode: error.code,
    statusMessage: error.message,
  })
}
</script>

<template>
  <autobid-page :key="slug" :slug="slug" @error="handleError">
    <template #default="{ pageData }">
      <CommonStrapiPage v-if="pageData?.page" :page-data="pageData" />
    </template>
  </autobid-page>
</template>
